import { type BlockVisibilityProtocol, type FilterFormType, VISIBILITY_STATUS } from '@lighthouse/core'
import { DEVELOPER, filterRecordChecker, recTakeFilterVariable, useAtomData } from '@lighthouse/shared'
import { isEmpty } from 'rambda'
import { useCallback, useMemo } from 'react'

import { appRoleAtom } from '@/atoms/application/state'

import { useParseVariableWithSubscription } from './useParseVariable'

export const useVisibilityFilter = (usedFilters?: FilterFormType | FilterFormType[]) => {
    const userId = useAtomData(appRoleAtom)

    const usedVariables = useMemo(() => {
        if (!usedFilters) {
            return
        }

        const filters = Array.isArray(usedFilters) ? usedFilters : [usedFilters]
        const res = filters
            .flatMap(item => {
                return recTakeFilterVariable(item?.expression)
            })
            .filter(Boolean)
        if (res.length === 0) {
            return
        }

        return res
    }, [usedFilters])
    const parseVariable2Field = useParseVariableWithSubscription(usedVariables)

    return useCallback(
        (payload: { visibility?: BlockVisibilityProtocol }) => {
            const { visibility } = payload
            if (!visibility) {
                return VISIBILITY_STATUS.MOUNT
            }

            const { visibilityFilter, visible, isMount } = visibility
            if (!visible || visible === 'VISIBLE') {
                return VISIBILITY_STATUS.MOUNT
            }
            if (visible === 'HIDDEN') {
                if (isMount) {
                    return VISIBILITY_STATUS.HIDDEN
                }
                return VISIBILITY_STATUS.UNMOUNT
            }
            if (visible === 'FILTER' && userId === DEVELOPER) {
                return VISIBILITY_STATUS.MOUNT
            }
            const isVisible =
                visibilityFilter && !isEmpty(visibilityFilter)
                    ? filterRecordChecker({
                          filter: visibilityFilter,
                          getVariableToFieldValue: parseVariable2Field
                      })
                    : true
            if (!isVisible && isMount) {
                return VISIBILITY_STATUS.HIDDEN
            }
            return isVisible ? VISIBILITY_STATUS.MOUNT : VISIBILITY_STATUS.UNMOUNT
        },
        [parseVariable2Field, userId]
    )
}
